import { useQuery } from '@tanstack/react-query';
import { addressService } from '@/services';
import { QueryParams } from '@/services/apiClient';

export const addressKeys = {
  all: ['address'] as const,
  countries: () => [...addressKeys.all, 'countries'] as const,
  adminAreas: (countryId?: string) => [...addressKeys.all, 'adminAreas', countryId] as const,
  localities: (adminAreaId?: string, search?: string) => [...addressKeys.all, 'localities', adminAreaId, search] as const,
};

export const useAddressCountries = (search?: string, params: QueryParams = {}) => {
  const trimmedSearch = search?.trim();
  const queryParams: QueryParams = {
    _size: 200,
    ...params,
    ...(trimmedSearch ? { search: trimmedSearch } : {}),
  };
  return useQuery({
    queryKey: [...addressKeys.countries(), queryParams],
    queryFn: () => addressService.getCountries(queryParams),
    staleTime: 10 * 60 * 1000,
    select: (data) => data.content,
  });
};

export const useAddressAdminAreas = (countryId?: string, search?: string, params: QueryParams = {}) => {
  const trimmedSearch = search?.trim();
  const queryParams: QueryParams = {
    countryId,
    _size: 500,
    ...params,
    ...(trimmedSearch ? { search: trimmedSearch } : {}),
  };
  return useQuery({
    queryKey: [...addressKeys.adminAreas(countryId), queryParams],
    queryFn: () => addressService.getAdminAreas(queryParams),
    enabled: Boolean(countryId),
    staleTime: 10 * 60 * 1000,
    select: (data) => data.content,
  });
};

export const useAddressLocalities = (adminAreaId?: string, search?: string, params: QueryParams = {}) => {
  const trimmedSearch = search?.trim();
  const queryParams: QueryParams = {
    adminAreaId,
    _size: 50,
    ...params,
    ...(trimmedSearch ? { search: trimmedSearch } : {}),
  };

  return useQuery({
    queryKey: [...addressKeys.localities(adminAreaId, search), params],
    queryFn: () => addressService.getLocalities(queryParams),
    enabled: Boolean(adminAreaId),
    staleTime: 5 * 60 * 1000,
    select: (data) => data.content,
  });
};
